<template>
  <span :class="`delta-overlay ${classes}`">
    {{ text }}
    <sup
      v-if="delta > 0"
      :class="`delta-overlay__delta ${delta_classes}`"
    >
      <span> +{{ delta }} </span>
    </sup>
  </span>
</template>

<script>
export default {
  name: 'delta-overlay',
  props: {
    text: String,
    delta: Number,
    classes: {
      type: String,
      default: () => '',
    },
    delta_classes: {
      type: String,
      default: () => '',
    },
  },
};
</script>

<style lang="scss" scoped>

  .delta-overlay {
    position: relative;

    &__delta {
      font-size: $font-size-sm;
      font-weight: $vb-font-weight-semibold;
    }
  }
</style>
